import { imageURL } from '../components/images';

export const getTourOperatorLogoUrl = (tourOperator, settings, preset = 'x192') => {
    if (!settings?.images?.base || !tourOperator?.logo?.p || !tourOperator?.logo?.s) {
        return null;
    }
    return imageURL(settings.images.base, tourOperator.logo, preset);
};
